<template>
  <tr :class="isOption && item.packages ? 'package-option' : ''">
    <td><i class="fa fa-fw fa-link" v-if="isOption"></i>{{ id }}</td>
    <td>
      <div class="btn-group">{{ name }}</div>
      <div v-if="isReservationDescVisible">{{ item.reservation_desc }}</div>
      <div class="flex-row">
        <div class="btn-group" v-if="item.product_id">
          <!-- <a class="btn btn-sm bg-info" href="javascript:;" v-for="resource in resources" v-on:click="resourceClicked(resource)"><i class="fa fa-fw fa-cube"></i> {{ resource.name }}</a>-->
          <span class="btn btn-sm bg-info" style="cursor: pointer; pointer-events:none" v-for="resource in resources"><i class="fa fa-fw fa-cube"></i> {{ resource.id }}: {{ resource.name }}</span>
        </div>

        <a :class="parseInt(valuecard.status) ? 'btn btn-sm bg-success valuecard' : 'btn btn-sm bg-danger valuecard'" href="javascript:;" v-for="valuecard in valuecards" v-on:click="valuecardClicked(valuecard)"><i class="fa fa-fw fa-credit-card"></i> {{ valuecard.name }}</a>
        <a class="btn btn-default btn-sm valuecards" href="javascript:;" v-if="allCodes" v-on:click="showAllCodes"><i class="fa fa-fw fa-credit-card"></i> {{ _('All codes') }}</a>
      </div>
      <div v-if="item.special && item.special !== 'groupdeal' && item.special !== 'margin_travel_agent' && item.special !== 'null'"><i>{{ item.special }}</i></div>
      <div v-if="formResponse" style="font-size: 0.9em">
        <div v-for="(value, key) in formResponse" :key="key">
          <strong>{{ key }}:</strong> <span style="white-space: pre-line">{{ value }}</span>
        </div>
      </div>
    </td>
    <td>{{ $filters.num(item.count) }}</td>
    <td class="hidden-print">{{ $filters.currency(item.price, item.currency) }}</td>
    <td class="hidden-print">{{ $filters.currency(item.price * item.count, item.currency) }}</td>
  </tr>
</template>

<script>
import orderitems from '~/lib/orderitems'
import modals from '~/lib/modals'
import { AllCodes } from '#components'

export default {
  mixins: [orderitems, modals],
  props: ['isOption', 'item', 'parentItem'],
  computed: {
    hasActiveValuecards () {
      return this.valuecards.some(v => parseInt(v.status))
    },
    productreservation () {
      return this.item.ownProductreservation && this.item.ownProductreservation[0] ? this.item.ownProductreservation[0] : null
    },
    resources () {
      return this.productreservation ? this.productreservation.sharedResource : []
    },
    valuecards () {
      return this.item.ownValuecard
    },
    allCodes () {
      if (this.valuecards && this.valuecards.length && this.hasActiveValuecards) {
        return this.valuecards.filter(v => parseInt(v.status)).map(v => v.code)
      }
      return null
    },
    isReservationDescVisible () {
      return this.item && this.productreservation && this.item.product && !parseInt(this.item.product.hide_units)
    },
    formResponse() {
      if (!this.item.formresponse) {
        return null
      }
      try {
        return JSON.parse(this.item.formresponse)
      } catch {
        return this.item.formresponse
      }
    }
  },
  methods: {
    showAllCodes () {
      this.showModal('allcodes', AllCodes, {
        props: {
          allCodes: this.allCodes
        },
        events: {},
        handlers: {},
        width: 600
      })
    }
  }
}
</script>

<style scoped>
tr.package-option > td:first-child {
  background-color: #d9edf7;
}
</style>